import React, { useEffect, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { SingleSelect } from '../select-types/SingleSelect.js';
import { UtilService } from '../../services/UtilService.js';
import Excel from './Excel.js';
import { Item } from '../../models.ts';
import EditCalculator from './EditCalculator.js';

const DeckCalculator = ({ deckObj, deckMap, isAdmin, handleSubmit }) => {
  const [deckState, setDeckState] = useState({});
  const [disableCalculate, setDisableCalculate] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const utilService = new UtilService();

  useEffect(() => {
    if (deckObj && deckMap) {
      let obj = { ...deckObj };
      deckObj.fields.forEach(field => {
        obj[field.id] = { ...field };
      });
      setDeckState(obj);
    }
    return () => {
      setDeckState({});
      setDisableCalculate(true);
    };
  }, [deckObj, deckMap]);

  function handleChange(field, value) {
    switch (field.type) {
      case 'select':
        let item = deckMap[field.collection].find(i => i.id === value);
        field.selection = JSON.parse(JSON.stringify(item));
        break;
      case 'text':
      case 'number':
        if (!field.selection) {
          field.selection = new Item();
        }
        field.selection.value = field.type === 'number' ? Number(value) : value;
        break;
      default:
        break;
    }

    if (field.id === 'handicapRamp') {
      const handicapTurnaroundField = deckState['handicapTurnaround'];
      if (field.selection.name === 'Yes') {
        handicapTurnaroundField.show = true;
      } else {
        handicapTurnaroundField.show = false;
        handicapTurnaroundField.selection = undefined;
      }
      deckState['handicapTurnaround'] = handicapTurnaroundField;
    }

    let width = deckState.fields.find(i => i.id === "width");
    let length = deckState.fields.find(i => i.id === "length");
    let footing = deckState.footing;

    if (width?.selection?.value
      && length?.selection?.value
      && (field.id === 'width' || field.id === 'length')
    ) {
      let sqft = width.selection.value * length.selection.value;
      let footingSelection = deckMap.Footings.find(i => i.id === "1");

      if (sqft >= 100) {
        if (footingSelection) {
          footing.selection = footingSelection;
          footing.disabled = true;
        }
      } else {
        footing.disabled = false;
      }
      deckState['footing'] = footing;
    }

    setDeckState({ ...deckState, [field.id]: field });
    checkDisabled();
  }

  function checkDisabled() {
    let disabled = false;
    if (deckState?.fields?.length) {
      for (let field of deckState.fields) {
        if (deckState[field.id].show && deckState[field.id].required && !disabled) {
          if (field.type === 'select') {
            disabled = deckState[field.id].selection === undefined;
          } else if (field.type === 'text') {
            disabled = !deckState[field.id].selection?.value?.length;
          } else if (field.type === 'number') {
            disabled = !deckState[field.id].selection?.value || deckState[field.id].selection?.value === 0;
          }
        }
      }
    }
    setDisableCalculate(disabled);
  }

  function calculate() {
    let newObj = handleSubmit(deckState, deckMap);
    setDeckState({ ...newObj });
  }

  function onEdit() {
    document.getElementById('container').style.width = isEditing ? '300px' : '90vw';
    setIsEditing(!isEditing);
  }

  if (isEditing) {
    return (
      <EditCalculator title={'Deck Calculator'}
        calculator={deckState}
        itemList={deckMap}
        onFinish={onEdit}
      />
    )
  } else {
    return (
      <div>
        <div>
          {isAdmin &&
            <Button variant='outlined' onClick={onEdit}>
              {isEditing ? 'Done' : 'Edit'}
            </Button>
          }
          <h1>Deck Calculator</h1>
        </div>
        <div>
          {deckState.fields?.length &&
            deckState.fields.map(field => {
              if (deckState[field.id].show) {
                return (
                  <div key={field.id}>
                    {field.type === 'select' &&
                      <SingleSelect
                        field={deckState[field.id]}
                        label={field.name}
                        optionList={deckMap[field.collection]}
                        handleChange={handleChange}>
                      </SingleSelect>
                    }
                    {(field.type === 'text' || field.type === 'number') &&
                      <TextField
                        error={deckState[field.id].required &&
                          (!deckState[field.id].selection?.value || deckState[field.id].selection?.value === 0)}
                        label={field.name}
                        disabled={deckState[field.id].disabled}
                        defaultValue={deckState[field.id].value || ''}
                        helperText={null}
                        required={field.required}
                        onChange={(e) => handleChange(field, e.target.value)}
                        variant="standard"
                      />
                    }
                    {!field.type &&
                      <div className='total'>
                        <span>{field.name} = </span>
                        <span>{utilService.formatCurrency(deckState[field.property]) || 0}</span>
                      </div>
                    }
                  </div>
                )
              } else {
                return null;
              }
            })
          }
        </div>
        <div className='buttonGroupSpaced'>
          <Button variant="outlined"
            onClick={calculate}
            disabled={disableCalculate}
          >
            Calculate
          </Button>
          {!disableCalculate && deckState.total > 0 &&
            <Excel calc={deckState}></Excel>
          }
        </div>
      </div>
    );
  }
};

export default DeckCalculator;